import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
export default {
    methods: {
        // 查看/修改获取单条GET /api/HiOrder/GetHiOrderById
        getList(orderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: orderId
            };
            this.ListData = []
            $http.get("api/HiOrder/GetHiOrderById", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {

                    this.form = util.filterAndSetData(this.form, Data) //过滤数据
                    // 收货地址赋值
                    this.addressData.ConsigneeProvId = Data.SchoolProvincesId
                    this.addressData.ConsigneeCityId = Data.SchoolCityId
                    this.addressData.ConsigneeAreaId = Data.SchoolAreaId
                    this.addressData.ConsigneeAddress = Data.SchoolAddress
                    this.addressData.Consignee = Data.SchoolConsignee
                    this.addressData.ConsigneeTel = Data.SchoolConsigneeTel
                    // 代理商主联系人，代理商公司，代理商所在区域，代理商联系电话
                    this.agent = Data.AgentInfo.C_Name + '  ' + Data.AgentInfo.AgentName + '  ' + Data.AgentInfo.ShortAddress + '  ' + Data.AgentInfo.C_Tel
                    //园所名称，园长姓名及园长电话
                    this.school = Data.SchoolInfo.SchoolName + '  ' + Data.SchoolInfo.PrincipalName + '  ' + Data.SchoolInfo.PhoneNo
                    this.ConsigneeList = Data.SchoolProvName + '  ' + Data.SchoolCityName + '  ' + Data.SchoolAreaName + '  ' + Data.SchoolAddress //收货地址
                    this.ConsigneeListName = Data.SchoolConsignee + '  ' + Data.SchoolConsigneeTel //联系人及电话

                    // 获取资源包数据
                    for (let i = 0; i < Data.GoodsList.length; i++) {
                        for (let j = 0; j < this.PackageDetails.length; j++) {
                            if (Data.GoodsList[i].ProId == this.PackageDetails[j].ProId) {
                                this.PackageDetails[j].ProNum = Data.GoodsList[i].ProNum
                            }
                        }

                    }
                    this.form.Remark = Data.Remark
                    this.PackageName = Data.PackageName
                    this.payList = cloneDeep(Data.ListMeetPay)
                    // this.PayListData = cloneDeep(Data.ListPay)

                });
            });
        },
        // 获取收货地址
        getSchoolConsigneeList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                schoolId: id
            };

            $http.get("api/School/GetSchoolConsigneeList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.SchoolConsigneeList = Data;
                    for (let i = 0; i < this.SchoolConsigneeList.length; i++) {
                        //IsDefault==1为默认地址

                        if (this.SchoolConsigneeList[i].IsDefault == 1) {

                            this.ConsigneeList = this.SchoolConsigneeList[i].ConsigneeProvinceName + '  ' + this.SchoolConsigneeList[i].ConsigneeCityName + '  ' + this.SchoolConsigneeList[i].ConsigneeAreaName + '  ' + this.SchoolConsigneeList[i].ConsigneeAdress
                            this.ConsigneeListName = this.SchoolConsigneeList[i].Consignee + '  ' + this.SchoolConsigneeList[i].ConsigneeTel
                            this.form.SchoolConsigneeId = this.SchoolConsigneeList[i].Id

                            //设置地址
                            this.addressData.ConsigneeProvId = this.SchoolConsigneeList[i].ConsigneeProvince
                            this.addressData.ConsigneeCityId = this.SchoolConsigneeList[i].ConsigneeCity
                            this.addressData.ConsigneeAreaId = this.SchoolConsigneeList[i].ConsigneeArea
                            this.addressData.ConsigneeAddress = this.SchoolConsigneeList[i].ConsigneeAdress
                            this.addressData.Consignee = this.SchoolConsigneeList[i].Consignee
                            this.addressData.ConsigneeTel = this.SchoolConsigneeList[i].ConsigneeTel


                        }
                    }
                });
            });
        },
        //新增POST /api/HiOrder/HiOrderAdd
        getAddOrderList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            $http.post("api/HiOrder/HiOrderAdd", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {

                    this.$notify({
                        title: '成功',
                        message: '开课成功',
                        type: 'success'
                    });
                    this.$emit('getTableList')
                    this.AddDialogVisible = false

                    this.initData();
                });
            });
        },

        //修改提交POST /api/HiOrder/HiOrderUpdate
        getUpdateOrderList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;
            $http.post("api/HiOrder/HiOrderUpdate", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    });

                    this.AddDialogVisible = false
                });
            });
        },
        // 获取套餐资源包下拉明细
        getDetailsPackage() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                PackageId: 500,
            };
            this.loading = true;
            $http.get("api/ContinueOrder/GetPackageDetailById", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                this.PackageDetails = []
                util.doResult(this, res, () => {
                    let len = Data.length
                    for (let i = 0; i < len; i++) {
                        this.PackageDetails.push({
                            ProId: 0,
                            ProName: "",
                            ProNum: 0
                        })
                        this.PackageDetails[i].ProId = Data[i].ProId
                        this.PackageDetails[i].ProName = Data[i].ProName

                    }
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/HiOrder/addOrderDialog/services.js